import { useThrottledCallback } from "@mantine/hooks";
import IconLayoutSidebarLeftCollapse from "@src/assets/icons/tabler/layout-sidebar-left-collapse.svg?react";
import IconLayoutSidebarLeftExpand from "@src/assets/icons/tabler/layout-sidebar-left-expand.svg?react";
import { useMenuState } from "@src/components/layouts/menu/menu-drawer";
import clsx from "clsx";

const DESKTOP_ICON_SIZE = 18;
const MOBILE_ICON_SIZE = 24;

export function NavigationToggleButton() {
	const { isDrawerOpen, toggleDrawer, isDesktop } = useMenuState();

	const handlePointerDown = useThrottledCallback(toggleDrawer, 100);
	const Icon = isDrawerOpen
		? IconLayoutSidebarLeftCollapse
		: IconLayoutSidebarLeftExpand;
	const iconSize = isDesktop ? DESKTOP_ICON_SIZE : MOBILE_ICON_SIZE;

	return (
		<button
			type="button"
			onPointerDown={handlePointerDown}
			title={isDrawerOpen ? "Close navbar" : "Open navbar"}
			aria-label={isDrawerOpen ? "Close navbar" : "Open navbar"}
			className={clsx(
				"flex shrink-0 items-center justify-center rounded-md",
				"border border-transparent",
				"text-text-secondary hover:text-text-primary",
				"hover:bg-surface-hover-subtle cursor-pointer",
				"transition-colors",
				// Match UserButton "Close navbar" (h-7 w-7). Mobile keeps a
				// larger hit target and icon in the top menu bar.
				isDesktop
					? "h-7 w-7 bg-transparent"
					: "h-10.5 w-10.5 bg-surface-subtle",
			)}
		>
			<Icon width={iconSize} height={iconSize} strokeWidth={1.5} />
		</button>
	);
}
